import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import camelCase from 'lodash.camelcase';
import merge from 'lodash.merge';
import { Redirect } from 'react-router';
import { withTheme } from 'glamorous';
import { ServiceDialog } from '../../../../../../common/components/Layout/StandardPageTemplate/Context';
import ErrorList from '../../../../../../common/components/ErrorList';
import { getDisplayPrice } from '../../../../../../common/utils/format-currency';
import { setPropByPath } from '../../../../../../common/utils/property-path';
import CurrentUserActions from '../../../../../../redux-modules/current-user';
import { withLoading } from '../../../../../../redux-modules/loading-overlay';
import CustomerActions from '../../../../../../redux-modules/customers';
import RegistrationActions from '../../../../actions/registration';
import fieldConfig from './FieldConfig';
import PriceChipList from './PriceChipList';
import { actionContainer, Total } from './styles';
import {Button} from '../../../../../../common/components';

export const RegistrationStatus = {
  UNKNOWN: 0,
  REGISTERED: 1,
  REGISTRATION_FAILED: 2,
  PAYMENT: 3,
};

class RegistrationForm extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    event: PropTypes.shape({
      isRemote: PropTypes.bool,
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_POST',
      },
    ],
  };

  constructor(props) {
    super(props);
    this.state = {
      price: undefined,
      guestPrice: undefined,
      serviceError: false,
      form: {
        ...Object.keys(fieldConfig).reduce((acc, curr) => {
          if (fieldConfig[curr].readOnly) {
            return acc;
          }
          return {
            ...acc,
            [curr]: '',
          };
        }, {}),
        guestNames: [{ firstName: '', lastName: '' }],
        ...this.loadCustomerFieldsFromProps(props),
      },
      registrationStatus: RegistrationStatus.UNKNOWN,
      errors: {
        request: {},
        guestNames: [{ firstName: '', lastName: '' }],
      },
    };
  }

  componentWillReceiveProps({ currentCustomer: customer }) {
    this.mergeState({
      form: {
        customer,
        organizationName: this.buildOrganizationName(customer),
      },
    });
  }

  // not a fan of this, but time is limited
  mergeState = (nextState, callback) => {
    this.setState(prevState => {
      return merge({}, prevState, nextState);
    }, callback);
  };

  loadCustomerFieldsFromProps = props => {
    const { currentCustomer, currentUser = {} } = props;
    const { email: newCustomerEmail } = currentUser.settings || {};
    const { personalDetails, contactDetails, summaryDetails } =
      currentCustomer || {};
    const { firstName, lastName } = personalDetails || {};
    const { emailAddress: knownCustomerEmail } = contactDetails || {};
    const { organizationUnboundName } = summaryDetails || {};

    return {
      customer: currentCustomer,
      firstName: firstName || '',
      lastName: lastName || '',
      organizationUnboundName: organizationUnboundName || '',
      badgeName: `${firstName || ''}${(firstName || '').length
        ? ' '
        : ''}${lastName || ''}`,
      emailAddress: knownCustomerEmail || newCustomerEmail || '',
    };
  };

  checkPassword = ({ name, value, prevState }) => {
    const message = 'Must match previous password.';

    // check value of confirm password when it changes
    if (name === 'confirmPassword' && value !== prevState.form.password) {
      return message;
    }

    // when either password is edited, clear error if they match
    if (
      (name === 'confirmPassword' && value === prevState.form.password) ||
      (name === 'password' && value === prevState.form.confirmPassword)
    ) {
      return '';
    }

    return prevState.errors.confirmPassword || '';
  };

  buildBadgeName = ({ name, value, prevState }) => {
    const firstName = name === 'firstName' ? value : prevState.form.firstName;
    const lastName = name === 'lastName' ? value : prevState.form.lastName;

    return `${firstName}${firstName.length ? ' ' : ''}${lastName || ''}`;
  };

  handleOnChange = name => (value, validation) => {
    const { isValid = true, message = '', restrictInput } = validation || {};
    return this.setState(prevState => {
      // handle badge name
      const updatedBadgeName =
        prevState.updatedBadgeName || name === 'badgeName';

      return {
        updatedBadgeName,
        form: {
          ...prevState.form,
          badgeName: !updatedBadgeName
            ? this.buildBadgeName({ name, value, prevState })
            : prevState.form.badgeName,
          [name]: !isValid && restrictInput ? prevState.form[name] : value,
        },
        errors: {
          ...prevState.errors,
          [name]: isValid || restrictInput ? '' : message,
          confirmPassword: this.checkPassword({ name, value, prevState }),
          request: {},
        },
      };
    });
  };

  handleRequired = (name, value) => {
    if ((value || '').trim().length === 0) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [name]: 'This field is required.',
        },
      }));
    }
  };

  handleOnBlur = (name, required) => (evt, validation) => {
    const value = evt.target.value;

    if(name === 'prefix' || name === 'state')
     { 
       /* For some reason the dropdown control have to be clicked twice in order to be selected. 
        this is a workaround.
       */
       if(evt.target.type === 'text' && required){
          return this.handleRequired(name, value);
       } else {
          var elems = document.querySelectorAll('[class*="theme--values"]');
          for(var i = 0; i < elems.length; i++){
            if(elems[i].style.visibility != "") elems[i].style = "";
          else elems[i].style.visibility= "hidden";
          } 
         return;
        }
     }
     

    if (required) {
      return this.handleRequired(name, value);
    }

    if (name === 'password' && value !== this.state.form.confirmPassword) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          confirmPassword: 'Must match previous password.',
        },
      }));
    }

    const { isValid = true, message = '' } = validation || {};
    if (!isValid) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [name]: message,
        },
      }));
    }
  };

  handleSelectPrice = (price, guestPrice) => {
    this.setState(prevState => {
      const newGuest = { firstName: '', lastName: '' };
      let newGuestList = prevState.form.guestNames;

      if (price.isTable) {
        const { firstName, lastName } = prevState.form;
        newGuestList = [
          { firstName, lastName },
          ...Array(price.numberOfSeats - 1).fill(newGuest),
        ];
      }

      if (prevState.price && prevState.price.isTable && !price.isTable) {
        // reset guests
        newGuestList = [newGuest];
      }

      return {
        price,
        guestPrice,
        form: {
          ...prevState.form,
          guestNames: newGuestList,
        },
        errors: {
          ...prevState.errors,
          guestNames: Array(newGuestList.length).fill(newGuest),
        },
      };
    });
  };

  handleFieldValidation = ({ message, detailedErrors = [] }) => {
    const validationErrors = detailedErrors.reduce((acc, curr) => {
      let propNameParts = curr.propertyName.split('.');
      if (propNameParts[0].toLowerCase() === 'personalAddress'.toLowerCase()) {
        propNameParts.splce(0, 1);
      } else if (
        propNameParts[0].toLowerCase() === 'personalDetails'.toLowerCase()
      ) {
        propNameParts.splce(0, 1);
      }

      if (
        propNameParts[0].toLowerCase() === 'registrantBadgeName'.toLowerCase()
      ) {
        propNameParts[0] = 'badgeName';
      }

      if (propNameParts[1]) {
        if (propNameParts[1].toLowerCase() === 'stateCode'.toLowerCase()) {
          propNameParts[1] = 'state';
        } else if (
          propNameParts[1].toLowerCase() ===
          'organizationUnboundName'.toLowerCase()
        ) {
          propNameParts = ['organizationName'];
        }
      }

      if (curr.PropertyName === 'ContactDetails.PhoneNumbers[0].Number') {
        propNameParts = ['phoneNumber'];
      } else if (curr.PropertyName === 'Credentials.Password.Password') {
        propNameParts = ['password'];
      }

      const propPath = propNameParts.map(camelCase).join('.');
      return setPropByPath(acc, propPath, curr.message);
    }, {});
    this.mergeState({
      errors: { request: { message }, ...validationErrors },
    });
  };

  calculateTotal = () => {
    const { price, guestPrice, form: { guestNames: guests = [] } } = this.state;
    const priceAmt = price ? price.price || 0 : 0;
    const guestPriceAmt = guestPrice ? guestPrice.price || 0 : 0;
    const numGuests = guests.filter(
      guest => guest.firstName.trim() !== '' && guest.lastName !== ''
    ).length;
    return priceAmt + guestPriceAmt * numGuests;
  };

  buildGuestBadgeNames = (guests = [], price, event) => {
    // guests should not be blank; if it's a table, remove the first guest
    return guests
      .filter((guest, index) => {
        if (!event.isFree && price && price.isTable) {
          // if event is not free and price is a table price, exclude the first guest
          return (
            guest.firstName.trim() !== '' &&
            guest.lastName.trim() !== '' &&
            index !== 0
          );
        }
        return guest.firstName.trim() !== '' && guest.lastName.trim() !== '';
      })
      .map(guest => `${guest.firstName.trim()} ${guest.lastName.trim()}`);
  };

  buildOrganizationName = customer => {
    if (!customer) {
      return '';
    }
    const { organization, summaryDetails } = customer;
    if (
      organization &&
      organization.organizationDetails &&
      organization.organizationDetails.name
    ) {
      return organization.organizationDetails.name;
    }
    if (summaryDetails && summaryDetails.organizationUnboundName) {
      return summaryDetails.organizationUnboundName;
    }
    return '';
  };

  registerForEvent = () => {
    const { event, actions: { register } } = this.props;
    const { form, price } = this.state;

    const registrationDetails = {
      eventKey: event.key,
      individualKey: form.customer.key,
      registrantBadgeName: form.badgeName,
      organizationName: form.organizationName,
      guestBadgeNames: this.buildGuestBadgeNames(
        form.guestNames,
        price,
        event
      ),
    };

    if (!event.isFree) {
      return this.setState({
        registrationStatus: RegistrationStatus.PAYMENT,
      });
    }

    return register
      .post(registrationDetails)
      .then(({ payload: { json, resp } }) => {
        if (resp.ok) {
          this.mergeState({
            registrationStatus: RegistrationStatus.REGISTERED,
            errors: { form: [] },
          });
        } else {
          this.mergeState({
            registrationStatus: RegistrationStatus.REGISTRATION_FAILED,
          });
          if (resp.status === 500) {
            this.setState({ serviceError: true });
          } else if (resp.status === 409) {
            this.mergeState({
              errors: { form: ['You are already registered for this event.'] },
            });
          } else {
            this.handleFieldValidation(json);
          }
        }
        window.scrollTo(0, 0);
        return Promise.resolve({ json, resp });
      });
  };
  createCustomer = () => {
    const { organization } = this.props.currentCustomer || {};
    const {
      prefix,
      firstName,
      lastName,
      streetLine1,
      streetLine2,
      city,
      state,
      postalCode,
      phoneNumber,
      emailAddress,
      password,
      organizationName,
    } = this.state.form;

    const customerToSave = {
      credentials: {
        username: emailAddress,
        password: password,
      },
      personalDetails: {
        lastName: lastName,
        firstName: firstName,
        prefix: prefix,
      },
      personalAddress: {
        addressLine1: streetLine1,
        addressLine2: streetLine2,
        city: city,
        stateCode: state,
        postalCode,
        type: 1,
      },
      contactDetails: {
        emailAddress: emailAddress,
        phoneNumbers: [],
      },
    };

    if (phoneNumber) {
      customerToSave.contactDetails.phoneNumbers[0] = {
        // strip spaces
        Number: phoneNumber.toString().replace(/\s+/g, ''),
        Type: 1,
      };
    }

    // only add organization name if you don't have org
    if (!organization) {
      customerToSave.summaryDetails = {
        organizationUnboundName: organizationName,
      };
    }
    delete customerToSave.summaryDetails;
    return this.props.actions.customer
      .post(customerToSave)
      .then(({ payload: { json, resp } }) => {
        if (resp.ok) {
          this.mergeState({
            errors: { form: [] },
          });
        } else {
          if (resp.status === 500) {
            this.setState({ serviceError: true });
          } else if (resp.status === 409) {
            this.mergeState({
              errors: {
                request: {
                  message:
                    'An existing user is currently associate with this email address. ',
                },
              },
            });
          } else {
            this.handleFieldValidation(json);
          }
        }
        return Promise.resolve({ json, resp });
      });
  };

  handleSubmit = evt => {
    evt.preventDefault();
    const { form, errors, price } = this.state;
    const { currentUser, event: { isFree } = {} } = this.props;
    let missingRequired = false;

    // check that all required fields have values
    const validationErrors = Object.keys(form).reduce((acc, curr) => {
      const formValue = form[curr] || '';
      const formDef = fieldConfig[curr] || {};

      if (formDef.hide && formDef.hide(this.props)) {
        return {
          ...acc,
          [curr]: errors[curr],
        };
      }

      if (formDef.required && formValue.trim().length === 0) {
        missingRequired = true;
        return {
          ...acc,
          [curr]: 'This field is required.',
        };
      }
      return {
        ...acc,
        [curr]: errors[curr],
      };
    }, {});

    if (missingRequired) {
      return this.setState(prevState => ({
        ...prevState.errors,
        ...validationErrors,
        request: {
          message: 'Please correct the error(s) and try again.',
        },
      }));
    }

    // check that there are no validation errors
    if (
      Object.values(errors).some(err => {
        if (typeof err === 'string') {
          return (err || '').trim().length > 0;
        }
        if (Array.isArray(err)) {
          return (err || []).some(nestedErr =>
            (Object.values(nestedErr) || '').some(
              prop => prop.trim().length > 0
            )
          );
        }
        return false;
      })
    ) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          request: {
            message: 'Please correct the error(s) and try again.',
          },
        },
      }));
    }

    // check that a price has been selected
    if (!isFree && !price) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          request: {
            message: 'No registration type was selected.',
          },
        },
      }));
    }
    if (currentUser.id) {
      // if user is known
      return this.registerForEvent();
    } else {
      // if user is unknown:
      // - first create new customer
      this.createCustomer().then(({ json: { key }, resp }) => {
        if (resp.ok) {
          this.props.actions.currentUser.setId(key);
          this.mergeState(
            {
              form: {
                customer: {
                  key: key,
                },
              },
            },
            () => this.registerForEvent()
          );
        }
      });
    }

    // just to ensure it doesn't refresh
    return false;
  };

  render() {
    const {
      form,
      price,
      guestPrice,
      errors,
      registrationStatus,
      serviceError,
    } = this.state;
    const {
      currentUser,
      event,
      theme: { color } = {},
      userPrices,
      isUserMember,
    } = this.props;
    const { isFree } = event || {};
    const eventFull = sessionStorage.getItem("engage-eventfull");
    if (eventFull != null && eventFull === "true") {
      return (
        <p id="thanksMessage">
          Thank you for your interest in this NFIB event.
    <br />
          Currently, no seats are available.
     <br />
          If you have questions, please contact NFIB by calling the number provided in the event description or 1-800-NFIB-NOW.
  </p>
      );
    } else if (eventFull === "false"){
    return (
      <form onSubmit={this.handleSubmit}>
        <h2>{'Register'}</h2>
        {serviceError && <ServiceDialog />}
        {errors && (
          (() => {
            const generalMessage = errors.request && errors.request.message;
            
            // Collect all string error messages from field-level errors
            const collectFieldErrors = (obj, parentKey = '') => {
              const messages = [];

              for (const key in obj) {
                if (key === 'request') continue; // skip request (handled separately)

                const value = obj[key];

                if (typeof value === 'string' && value) {
                  messages.push(value);
                } else if (typeof value === 'object' && value !== null) {
                  messages.push(...collectFieldErrors(value, key));
                }
              }

              return messages;
            };

            const fieldErrors = collectFieldErrors(errors);

            const allErrors = [
              ...(generalMessage ? [generalMessage] : []),
              ...fieldErrors,
            ];

            return allErrors.length > 0 ? (
              <ErrorList errors={allErrors} offsetTop={300} />
            ) : null;
          })()
        )}
        {event.numberOfSeatsAvailable >= 1 && event.numberOfSeatsAvailable <= 5 && (
          <h6 style={{color: '#E53935'}}>
            {`${event.numberOfSeatsAvailable.toString()} seat${event.numberOfSeatsAvailable !== 1 ? 's' : ''} remaining`}
          </h6>
        )}
        <PriceChipList
          organization={form.customer && form.customer.organization}
          currentUser={currentUser}
          event={event}
          userPrices={userPrices}
          isUserMember={isUserMember}
          priceSelectionHandler={this.handleSelectPrice}
        />
        {Object.keys(fieldConfig).map(key => {
          const {
            disable = {},
            hide = {},
            showCounter = {},
            readOnly,
            component: Component,
            ...rest
          } = fieldConfig[key];

          if (
            !fieldConfig[key] ||
            !Component ||
            (typeof hide === 'function' && hide({...this.state, ...this.props}))
          ) {
            return null;
          }

          let inputProps = rest;

          if (!readOnly) {
            inputProps = {
              ...inputProps,
              onChange: this.handleOnChange(key),
              onBlur: this.handleOnBlur(key, rest.required),
              value: form[key],
              error: errors[key],
              ...(typeof disable === 'function' && {
                disabled: disable(this.props),
              }),
              ...(typeof showCounter === 'function' && {
                counter: showCounter(this.props),
              }),
            };
          }

          if (key === 'guestNames') {
            const { price: { isTable } = {} } = this.state;
            inputProps = {
              ...inputProps,
              isTable,
            };
          }

          return <Component key={key} {...inputProps} />;
        })}
        {!isFree ? (
          <div style={actionContainer}>
            <Total color={color}>{`Total: ${getDisplayPrice(
              this.calculateTotal()
            )}`}</Total>
          </div>
        ) : null}
        <div style={actionContainer}>
          <Button
            type="submit"
            label={isFree ? 'Submit' : 'Continue To Payment'}
          />
        </div>
        {registrationStatus === RegistrationStatus.REGISTERED && (
          <Redirect to={`/events/${event.key}/confirmation`} />
        )}

        {registrationStatus === RegistrationStatus.PAYMENT && (
          <Redirect
            push // this is needed so that we don't overwrite our place in browserHistory
            to={{
              pathname: `/events/${event.key}/payment`,
              state: {
                event,
                price,
                guestPrice,
                registrationDetails: {
                  eventKey: event.key,
                  individualKey: form.customer.key,
                  registrantBadgeName: form.badgeName,
                  organizationName: form.organizationName,
                  guestBadgeNames: this.buildGuestBadgeNames(
                    form.guestNames,
                    price,
                    event
                  ),
                },
              },
            }}
          />
        )}
      </form>
    );
          }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    currentUser: bindActionCreators(CurrentUserActions, dispatch),
    register: bindActionCreators(RegistrationActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(
  withTheme(withLoading(RegistrationForm))
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/index.js